import { setWindowLocation } from '@eventbrite/http';
import { useLocationContext } from '../context';
import { AnalyticsOptions, SearchParamsForUrl } from '../types';
import { constructSearchUrl, trackSearchTakeoverEvent } from '../utils';
import { useSearchAutocompleteHistory } from './cache';

const storyQuery = ({
    query,
    rawStoredQueries,
    formattedStoredQueries,
    callback,
}: {
    query: string;
    rawStoredQueries: string;
    formattedStoredQueries: string[];
    callback: (item: string) => void;
}) => {
    if (query) {
        if (!rawStoredQueries) {
            callback(`${query.toLowerCase()}`);
        } else {
            const recentQuerySet = new Set(formattedStoredQueries);

            if (!recentQuerySet.has(query.toLowerCase())) {
                callback(`${query.toLowerCase()},${rawStoredQueries}`);
            }
        }
    }
};

export const useRunSearch = () => {
    const { location, setLocationCookie } = useLocationContext();
    const [formattedValue, setValue, rawValue] = useSearchAutocompleteHistory();

    const callback = ({
        url,
        search,
        analytics,
    }: {
        url?: string;
        search?: SearchParamsForUrl;
        analytics?: AnalyticsOptions | AnalyticsOptions[];
    }) => {
        let searchUrl = url;

        if (!url && !!search) {
            searchUrl = constructSearchUrl({ search, location });
        }

        !!location && setLocationCookie?.(location);

        storyQuery({
            query: search?.q || '',
            rawStoredQueries: rawValue,
            formattedStoredQueries: formattedValue,
            callback: setValue,
        });

        !!analytics && trackSearchTakeoverEvent(analytics);

        setWindowLocation(searchUrl);
    };

    return callback;
};
